import { Component, Inject, OnInit } from "@angular/core";
import { BaseComponent } from "../../shared/base/base.component";
import { SfAnalyticsService } from '../../services/sf-analytics.service';
import { LossReportService } from "../../services/loss-report.service";
import { RoutingService } from "../../services/routing.service";
import { Router } from "@angular/router";
import { LogService } from "../../services/log.service";

@Component({
  selector: 'olr-damage-photos',
  templateUrl: './damage-photos.component.html',
  styleUrls: ['./damage-photos.component.css', '../../shared/styles/question-common-styling.scss']
})
export class DamagePhotosComponent extends BaseComponent implements OnInit {

     constructor(
        @Inject('Window') private window: any,
        public lossReportService: LossReportService,
        public routingService: RoutingService,
        public router: Router,
        private analytics: SfAnalyticsService,
        public logService: LogService
        ) {
          super(lossReportService, router, routingService, logService);
         }
    ngOnInit(): void {
      // console.log('I will add tagging if necessary');
      this.analytics.sendData('damage-photos-question');
      this.analytics.setScreenChannel('filealoss-auto');
    }

    goToPhotoUploads() {
      this.router.navigate(['/damage-details/damage-photos-upload']);
    }
}
